module.exports = __webpack_public_path__ + "static/webroll02-bf711de862a442c41d138839458cea22.mp4";